import React, { useCallback, useEffect, useState } from 'react';
import { useDayPicker } from 'react-day-picker';
import {
  ChevronLeft,
  ChevronRight,
  NextMonthButton,
  PreviousMonthButton,
} from './NavButton.styles';
import { NavButtonProps } from './NavButton.types';
import { isAnotherMonthDisabled } from './NavButton.util';

export const NavButton = (props: NavButtonProps): JSX.Element => {
  const { previousMonth, nextMonth, goToMonth } = useDayPicker();
  const { navDirection, disabledDates, disableNavigation } = props;
  const anotherMonth = navDirection === 'next' ? nextMonth : previousMonth;
  const [isButtonDisabled, setIsButtonDisabled] = useState(
    anotherMonth
      ? isAnotherMonthDisabled(anotherMonth, disabledDates, navDirection)
      : false,
  );

  const handleButtonClick = useCallback(() => {
    anotherMonth && goToMonth(anotherMonth);
  }, [goToMonth, anotherMonth]);

  useEffect(() => {
    anotherMonth &&
      setIsButtonDisabled(
        isAnotherMonthDisabled(anotherMonth, disabledDates, navDirection),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anotherMonth]);

  const disabled =
    props['aria-disabled'] === 'true' || disableNavigation || isButtonDisabled;

  return navDirection === 'next' ? (
    <NextMonthButton
      data-testid="next-month-button"
      onClick={handleButtonClick}
      disabled={disabled}
      {...props}
    >
      <ChevronRight disabled={disabled} />
    </NextMonthButton>
  ) : (
    <PreviousMonthButton
      data-testid="previous-month-button"
      onClick={handleButtonClick}
      disabled={disabled}
      {...props}
    >
      <ChevronLeft disabled={disabled} />
    </PreviousMonthButton>
  );
};
